const initialState = {
  account: {},
  oauthPath: null,
  status: {
    isLoading: true
  }
}

const setLoading = (state, isLoading) => ({
  ...state,
  status: {
    isLoading
  }
})

const startLoading = (state) => setLoading(state, true)
const stopLoading = (state) => setLoading(state, false)

const accountLoaded = (state, {
  email_address: email,
  access_granted: accessGranted,
  oauth_path: oauthPath
}) => ({
  ...state,
  status: {
    isLoading: false
  },
  account: {
    email,
    accessGranted,
  },
  oauthPath
})

const accountDisconnected = (state) => ({
  ...state,
  account: {
    ...state.account,
    email: '',
  },
  status: {
    ...state.status,
    isLoading: false
  }
})

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case 'OUTLOOK_FETCH_ACCOUNT':
      return startLoading(state)
    case 'OUTLOOK_FETCH_ACCOUNT_SUCCESS':
      return accountLoaded(state, payload)
    case 'OUTLOOK_FETCH_ACCOUNT_COMPLETE':
      return stopLoading(state)
    case 'OUTLOOK_DISCONNECT_SUCCESS':
      return accountDisconnected(state)
    default:
      return { ...initialState, ...state }
  }
}
